export default __webpack_public_path__ + "static/media/afternoon-alt.b63be59e.svg";